import { createContext, useContext, useState } from 'react';

export const VIEW_SELECT_TEAM = 'v1';
export const VIEW_SELECT_SOFTWARE_WORKFLOW = 'v2';

type ViewType = typeof VIEW_SELECT_TEAM | typeof VIEW_SELECT_SOFTWARE_WORKFLOW;

type UserSegmentationContext = {
	userSegView?: ViewType;
	setUserSegView: React.Dispatch<React.SetStateAction<ViewType | undefined>>;
};

const UserSegmentationContext = createContext<UserSegmentationContext>({
	userSegView: undefined,
	setUserSegView: () => {
		throw new Error('Missing provider');
	},
});

export const useUserSegmentation = (): UserSegmentationContext => {
	const context = useContext(UserSegmentationContext);

	if (context === undefined) {
		throw new Error(
			'`useUserSegmentation` must be used within a `UserSegmentationContext.Provider`',
		);
	}
	return context;
};

export const UserSegmentationProvider = ({ children }: React.PropsWithChildren) => {
	const [userSegView, setUserSegView] = useState<ViewType>();

	return (
		<UserSegmentationContext.Provider value={{ userSegView, setUserSegView }}>
			{children}
		</UserSegmentationContext.Provider>
	);
};
